/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobIsArchivedQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobIsArchivedQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobIsArchivedQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobIsArchivedQueryOperator>): PolicyJobIsArchivedQueryOperator {
        let obj = Object.assign(new PolicyJobIsArchivedQueryOperator(), model);
        PolicyJobIsArchivedQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobIsArchivedQueryOperator>): PolicyJobIsArchivedQueryOperator {
        if (!model) return null;
        return PolicyJobIsArchivedQueryOperator.newInstance(<PolicyJobIsArchivedQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobIsArchivedQueryOperator) {
        if (!obj) return;

        models.PolicyJobIsArchivedQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobIsArchivedQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobIsArchivedQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy job is_archived to include
     */
    is_archived: Array<boolean>;

}
